import React from "react";
import FashionIcon from '../FashionIcon';
import styles from './list_styles.css';

export default class BreadcrumbList extends React.Component {
  static defaultProps = {
    labels: [],
    caretIconName: '',
    className: '',
    trackingProps: {}
  };

  handleClick = (e) => {
    var defaultParams = {
      selection: e.currentTarget.getAttribute('data-selection'),
      userDecisionArea: e.currentTarget.getAttribute('data-user-decision-area'),
      destinationUrl: e.currentTarget.href,
    };
    Fashion.currentView().trackBreadcrumbClick(e, defaultParams);
  }

  clickable = (labelText, Link, selection) => {
    let { trackingProps } = this.props;
    trackingProps['data-selection'] = selection;

    return <a className="breadcrumb-label" href={Link} {...trackingProps} onClick={this.handleClick}><span>{labelText}</span></a>
  };

  span = (labelText) => {
    return <span>{labelText}</span>
  };

  labelItem = (label, selection) => {
    if(Array.isArray(label)) {
      return this.nestedItems(label, selection)
    }

    const {label_text, link} = label;

    return <li>
             {
               this.props.caretIconName ? <FashionIcon name={this.props.caretIconName} size="md" ariaHidden="true" /> : <span className={styles['slash']}>/</span>
             } 
             {link && link.length ? this.clickable(label_text, link, selection) : this.span(label_text)}
           </li>;
  };

  nestedItems = (items, selection) => {
    return <li className={styles['nested-labels']}>
            {
              this.props.caretIconName ? <FashionIcon name={this.props.caretIconName} size="md" ariaHidden="true" /> : <span className={styles['slash']}>/</span>
            }
              {
               items.map((label) => {
                 const {label_text, link} = label;

                 return this.clickable(label_text, link, selection)
               })
             }
           </li>;
  };

  labelSelection = (labels, index) => {
    return labels.slice(0, index + 1).map((label) => {
      if(Array.isArray(label)) {
        return label.map((item) => { return item.label_text }).join(', ')
      }
      return label.label_text
    }).join(" > ");
  }

  render() {
    let {labels} = this.props;

    return <ol className={`${styles['breadcrumb-ol']} ${this.props.className}`}>
      {
        labels.map((label, index) => {
          var selection = this.labelSelection(labels, index);
          return this.labelItem(label, selection)
        })
      }
    </ol>
  }
}